import { createReducer } from '@reduxjs/toolkit'
import { matchResetStore } from './matchers';

const initialState = {
    isLoading: false,
    showLoading: true,
    actionStates: {}
}

function isInProgress(action) {
    return action.type.indexOf('IN_PROGRESS') > -1;
}
function isSuccessOrFailure(action) {
    return action.type.indexOf('_SUCCESS')  > -1 || action.type.indexOf('_FAILURE')  > -1;
} 

export const loading = createReducer(initialState, (builder) => {
    builder
    .addMatcher(isInProgress, (state, action) => {
        state.actionStates[action.type] = true;
        state.showLoading = action?.payload?.showLoading ?? true;
        state.isLoading = true;
    })
    .addMatcher(isSuccessOrFailure, (state, action) => {
        const actionsKey = action.type.replace(/_FAILURE|_SUCCESS/gi, '_IN_PROGRESS' );
        state.actionStates[actionsKey] = false;
        state.isLoading = false;
    })
    .addMatcher(matchResetStore, () => {
        return initialState;
    })
})